var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-popover',_vm._b({scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.titleHtml)}})]},proxy:true}])},'b-popover',_vm.$props,false),[_c('div',{domProps:{"innerHTML":_vm._s(_vm.bodyHtml)}})])}
var staticRenderFns = []

export { render, staticRenderFns }